<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_iii"></a>LAST DOG<br/>ON THE HILL</h1>
<p class="image"><img alt="Images" src="images/role.jpg"/></p>
<p class="sub-title">The Extraordinary<br/>Life of Lou</p>
<p class="image"><img alt="Images" src="images/title.jpg"/></p>
<p class="author">Steve Duno</p>
<p class="editor"><img alt="Images" src="images/pub.jpg"/><br/>St. Martin’s Press<br/>New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2773b346